import React, { useEffect, useState } from "react";
import { Checkbox, Progress } from "antd";
import playerImg from "assets/playervideo.png";
import { useLocation } from "react-router-dom";
import { checkItem, formatVideoUrl } from "utils";
import "./style.scss";
import { UserOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { api } from "services/api";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { IProgress } from "types";
import { AddTopicModal, Loading } from "components";
import { useForm } from "antd/lib/form/Form";

export const ModulePage: React.FC = () => {
	// @ts-ignore
	const { state }: { state: ICourse } = useLocation();
	const { id: userId } = useSelector((state: any) => state.app.user);
	const [value, setValue] = useState<string>("");
	const [moduleContent, setModuleContent] = useState<any[]>([]);
	const [forumTopics, setForumTopics] = useState<any[]>();
	const [topicId, setTopicId] = useState<string>("");
	const [topicsInfos, setTopicsInfos] = useState<any>();
	const [currentTopic, setCurrentTopic] = useState<any>();
	const [progress, setProgress] = useState<IProgress>();
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [forumClassId, setForumClassId] = useState<string>("");
	const [form] = useForm();
	const [titles, setTitles] = useState({
		moduleTitle: "",
		lessonTitle: "",
		lessonDescription: "",
		index: 1,
		currentClassId: "",
	});

	const [pageType, setPageType] = useState<string>("class");

	const course = state.courseGeneralInfo;

	const handleSendMessage = () => {
		api
			.post(`/topics/${topicId}/messages`, {
				id_topico: topicId,
				text: value,
				user_id: userId,
				is_active: true,
			})
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					api.get(`/topics/${topicId}/messages`).then((res) => {
						setTopicsInfos(res.data.data);
					});
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setValue("");
						form.resetFields();
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		const loadCourse = async () => {
			setTitles(course.currentModule);
		};

		if (course) {
			loadCourse();
		}
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		const getForumTopics = async () => {
			setForumTopics(undefined);
			if (forumClassId) {
				await api
					.get(`/forums/${forumClassId}/topics`)
					.then((r) => {
						setForumTopics(r.data.data.topics);
					})
					.catch((err) => {
						setForumTopics([]);
						console.log(err);
					});
			}
		};

		getForumTopics();
	}, [forumClassId]);

	useEffect(() => {
		const loadProgress = async () => {
			if (userId) {
				await api
					.get(`/courses/${course.id}/users/${userId}/progress`)
					.then((r) => {
						setProgress(r.data.data);
					});
			}
		};

		loadProgress();
	}, [userId, course]);

	useEffect(() => {
		const getData = async () => {
			await api.get(`/classes/${titles.currentClassId}/content`).then((res) => {
				if (res.data.data.blockes) {
					setModuleContent(res.data.data.blockes);
				}
			});

			await api.get(`/classes/${titles.currentClassId}`).then((res) => {
				if (res.data.data.forum) {
					setForumClassId(res.data.data.forum.id);
				}
			});
		};

		if (titles.currentClassId) {
			getData();
		}
	}, [titles]);

	return (
		<div className="module">
			<AddTopicModal
				setIsOpen={setIsOpen}
				isOpen={isOpen}
				forumId={forumClassId}
				form={form}
				setForumTopics={setForumTopics}
			/>
			<div className="module__container">
				<div
					className="module__container__info"
					style={{ height: pageType === "forum" ? "615px" : "" }}
				>
					<div className="module__container__info__header">
						<img
							src={course.image ? course.image : playerImg}
							width="150px"
							height="95px"
							alt=""
						/>
						<div className="module__container__info__header__content">
							<h1 className="module__container__info__header__content__title">
								{course.title}
							</h1>
							<p className="module__container__info__header__content__author">
								{course.author}
							</p>
							<p className="module__container__info__header__content__age-filter">
								Classificação indicativa: {course.age}
							</p>
							<div className="module__container__info__header__content__tags">
								{course.tags &&
									course.tags.map((item: string, index: number) => (
										<p key={index} className="tag">
											{item}
										</p>
									))}
							</div>
						</div>
					</div>
					<Progress
						percent={progress?.progress}
						strokeWidth={8}
						showInfo={false}
					/>
					<p className="percent">{progress?.progress}%</p>
					<hr />
					{pageType === "class" && (
						<div className="module__container__info__module-courses">
							{course.modules &&
								course.modules?.map((module: any, index: number) => {
									return (
										<div
											key={index}
											className="module__container__info__module-courses__module"
										>
											<h1 className="module__container__info__module-courses__module__title">
												{index + 1}. {module.title}
											</h1>
											<div className="module__container__info__module-courses__module__available-classes">
												{module.classes.length !== 0 &&
													module.classes.map((lesson: any, i: number) => {
														return (
															<div
																key={i}
																className={`module__container__info__module-courses__module__available-classes__class${
																	titles.currentClassId === lesson.id &&
																	titles.moduleTitle === module.title
																		? "--selected"
																		: ""
																}`}
																onClick={() => {
																	setForumTopics(undefined);
																	setTopicsInfos(undefined);
																	setTitles({
																		moduleTitle: module.title,
																		lessonTitle: lesson.title,
																		lessonDescription: lesson.description,
																		index: index + 1,
																		currentClassId: lesson.id,
																	});
																}}
															>
																<p>
																	{i + 1}. {lesson.title}
																</p>
																<Checkbox
																	onClick={(e: any) => {
																		if (e.currentTarget.checked) {
																			api.get(
																				`/classes/${lesson.id}/users/${userId}/finish`
																			);
																		}
																		checkItem(e);
																		setTitles({
																			moduleTitle: module.title,
																			lessonTitle: lesson.title,
																			lessonDescription: lesson.description,
																			index: index + 1,
																			currentClassId: lesson.id,
																		});
																	}}
																/>
															</div>
														);
													})}
												{module.classes.length === 0 && (
													<h1>Não há aulas disponíveis.</h1>
												)}
											</div>
										</div>
									);
								})}
						</div>
					)}

					{pageType === "forum" && (
						<>
							<div className="module__container__info__forum-topics__header">
								<h1 className="module__container__info__forum-topics__header__title">
									Fórum de dúvidas
								</h1>
								<button
									className="module__container__info__forum-topics__header__btn"
									onClick={() => setIsOpen(!isOpen)}
								>
									Criar tópico
								</button>
							</div>
							<div className="module__container__info__forum-topics">
								{forumTopics &&
									forumTopics.map((module: any, index: number) => {
										// console.log({ module });
										const { id, created_at } = module;
										return (
											<div
												key={index}
												className="module__container__info__forum-topics__topic"
												style={{ cursor: "pointer" }}
												onClick={() => {
													setTopicId(id);
													api.get(`/topics/${id}/messages`).then((res) => {
														setTopicsInfos(res.data.data);
													});
													setCurrentTopic(module);
												}}
											>
												<div className="module__container__info__forum-topics__topic__img">
													<UserOutlined twoToneColor="#000" />
												</div>
												<div className="info">
													<h1 className="module__container__info__forum-topics__topic__title">
														{module.subject}
													</h1>
													<div
														style={{
															display: "flex",
															flexDirection: "row",
															justifyContent: "space-between",
															width: "100%",
														}}
													>
														<p>Nome do criador do tópico</p>
														<p>Criado em: {created_at}</p>
													</div>
												</div>
											</div>
										);
									})}

								{!forumTopics && (
									<div
										style={{
											height: "100%",
											width: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										<Loading title="Tópicos" />
									</div>
								)}

								{forumTopics && !forumTopics?.length && (
									<p
										style={{
											height: "100%",
											width: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										Não há tópicos disponíveis.
									</p>
								)}
							</div>
						</>
					)}
				</div>

				{pageType === "class" && (
					<div className="module__container__lesson">
						<p className="module__container__lesson__module-title">
							{titles.index}. {titles.moduleTitle}
						</p>
						<h1 className="module__container__lesson__lesson-title">
							{titles.lessonTitle}
						</h1>
						<p className="module__container__lesson__description">
							{titles.lessonDescription}
						</p>
						<div className="module__container__lesson__content">
							{moduleContent.map((item) => {
								if (item.type === "youtube") {
									return (
										<div>
											<iframe
												title="Video"
												width="500px"
												height="300px"
												src={formatVideoUrl(item.content, true)}
											></iframe>
										</div>
									);
								}
								if (item.type === "archive") {
									return (
										<div
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												flexDirection: "column",
											}}
										>
											<p style={{ margin: 0, fontSize: "18px" }}>
												Arquivo em anexo:{" "}
											</p>
											<a
												href={item.content}
												target="_blank"
												rel="noreferrer"
												style={{ fontSize: "17px", margin: 0 }}
											>
												Abrir anexo
											</a>
										</div>
									);
								}
								if (item.type === "vimeo") {
									return (
										<div
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
											}}
										>
											<iframe
												src={formatVideoUrl(item.content, false)}
												width="520px"
												height="300px"
												title="video"
											></iframe>
										</div>
									);
								}
								if (item.type === "image") {
									return (
										<img
											src={item.content}
											style={{ width: "520px", height: "auto" }}
											alt=""
										></img>
									);
								}
								if (item.type === "text") {
									return (
										<p className="module__container__lesson__content__text">
											<div
												style={{ paddingLeft: "20px", paddingRight: "20px" }}
												dangerouslySetInnerHTML={{
													__html: item.content,
												}}
											></div>
										</p>
									);
								}
								return <></>;
							})}
						</div>
						<div className="module__container__lesson__btns">
							<button onClick={() => window.history.back()}>
								Acessar página do curso
							</button>
							<button onClick={() => setPageType("forum")}>
								Fórum de dúvidas
							</button>
						</div>
					</div>
				)}

				{pageType === "forum" && (
					<div className="module__container__forum">
						{topicsInfos?.messages && (
							<h1 className="module__container__lesson__module-title">
								Tópico atual: {currentTopic?.subject}
							</h1>
						)}
						<div className="module__container__forum__topics-container">
							{!topicsInfos?.messages && (
								<p
									style={{
										height: "100%",
										width: "100%",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									Selecione um tópico para visualizar suas respectivas
									mensagens.
								</p>
							)}

							{topicsInfos?.messages?.length === 0 && (
								<p
									style={{
										height: "100%",
										width: "100%",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									Ainda não há mensagens para exibir nesse tópico.
								</p>
							)}
							{topicsInfos?.messages.map(
								(
									{ message, user }: { message: any; user: any },
									index: number
								) => {
									console.log({ user });
									return (
										<div
											key={index}
											className="module__container__forum__topics-container__topic"
										>
											<div className="module__container__forum__topics-container__topic__img">
												<UserOutlined twoToneColor="#000" />
											</div>
											<div className="info">
												<h1
													style={{
														textTransform: "capitalize",
														margin: 0,
														lineHeight: "12px",
													}}
												>
													{user[0]?.username}
												</h1>
												<p style={{ fontWeight: "100" }}>
													Criado em: {message.created_at}
												</p>
												<div
													dangerouslySetInnerHTML={{
														__html: `<p>${message.text}</p>`,
													}}
												></div>
											</div>
										</div>
									);
								}
							)}
						</div>

						{topicsInfos?.messages && (
							<>
								<div className="module__container__forum__input">
									<ReactQuill theme="snow" value={value} onChange={setValue} />
								</div>
							</>
						)}
						<div className="module__container__forum__btns">
							<button onClick={() => setPageType("class")}>Voltar</button>
							{topicsInfos?.messages && (
								<button onClick={() => handleSendMessage()}>Enviar</button>
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
